import {
  Address,
  AloftArea,
  AloftCount,
  AloftDate,
  AloftPrice,
  expected,
} from '@aloft/toolkit-shared';
import { ToolkitPropertyFieldType } from '@aloft/toolkit-shared/lib/toolkitProperty/types';

import { TPTableSortBy } from './types';

export function getTPFieldSortBy(type: ToolkitPropertyFieldType): TPTableSortBy<any> {
  if (type === 'address') {
    return (a: Address, b: Address) => {
      return expected(a.AddressLineText).localeCompare(expected(b.AddressLineText));
    };
  }
  if (type === 'string') return (a: string, b: string) => a.localeCompare(b);
  if (type === 'number') return (a: number, b: number) => a - b;
  if (type === 'date') return (a: AloftDate, b: AloftDate) => a.compare(b);
  if (type === 'area') return (a: AloftArea, b: AloftArea) => a.compare(b);
  if (type === 'price') return (a: AloftPrice, b: AloftPrice) => a.compare(b);
  if (type === 'count') return (a: AloftCount, b: AloftCount) => a.compare(b);
  if (type === 'enum') return (a: string, b: string) => a.localeCompare(b);

  throw new Error(`No sort by function defined for ToolkitPropertyFieldType: ${type}.`);
}
